const LocaleConfig = {
    "AllRight": "[Хорошо]",
    "Ambulance": "[Скорая помощь]",
    "Angle": "[Ангел]",
    "Angry": "[Гнев]",
    "Applause": "[Аплодисменты]",
    "Awkward": "[Стыдно]",
    "Beckoning": "[Сердце]",
    "Bomb": "[Бомба]",
    "Broken": "[Сердце разбито]",
    "Bye": "[Пока]",
    "Cloud": "[облако петли]",
    "Cool": "[Круто]",
    "Cry": "[Плачет]",
    "Cute": "[Милый]",
    "Despise": "[Презрение]",
    "Disdain": "[Печально]",
    "Ecstasy": "[Радость]",
    "First": "[Первый]",
    "Fist": "[Кулак]",
    "Fretting": "[Нервничает]",
    "Frown": "[Хмурится]",
    "Funny": "[Смеется и плачет]",
    "Ghost": "[Призрак]",
    "GiveMeFive": "[Руки]",
    "GoodJob": "[Сила]",
    "Grimace": "[Гримас]",
    "Halo": "[Звёздные глаза]",
    "Happy": "[Рад]",
    "Hi": "[Помахал]",
    "Hit": "[Ударь тебя]",
    "Hold": "[Подержи.]",
    "Joy": "[Радость]",
    "Kiss": "[Поцелуй]",
    "Knife": "[Ножницы]",
    "Laugh": "[Смеется]",
    "Low": "[Низкий уровень]",
    "Mad": "[Гнев]",
    "Mask": "[Маска]",
    "Mischievous": "[Смеется]",
    "Monkey": "[Обезьяна]",
    "Nice": "[Хвала]",
    "No": "[Не надо]",
    "NoListen": "[Не слушаю]",
    "NoLook": "[Не смотри]",
    "NoWords": "[Не говорить]",
    "Ok": "[Хорошо]",
    "Pig": "[Свинья]",
    "Please": "[Амитабу]",
    "Poop": "[Пиздец]",
    "Rocket": "[Ракета]",
    "Sexy": "[Цвет]",
    "Shame": "[Застенчивый]",
    "Sleep": "[Спит]",
    "Sleeping": "[Спит]",
    "Snicker": "[Смеется]",
    "Spit": "[Высунь язык]",
    "Squint": "[Прищурился]",
    "Surprise": "[Удивлен]",
    "Sweat": "[Пот]",
    "Tears": "[Слезы]",
    "Terrorist": "[Ужас]",
    "Think": "[Мысли]",
    "Thrill": "[Испуганный]",
    "Tired": "[Звёздный]",
    "Uncomfortable": "[Тяжело]",
    "Unhappy": "[Неудовлетворительно]",
    "acceptFailedText": "Заявка отклонена.",
    "acceptResultText": "Согласовано",
    "acceptText": "Согласен.",
    "acceptedText": "Согласовано",
    "accountNotMatchText": "Нет этого счета.",
    "accountPlaceholder": "Введите номер счета.",
    "accountText": "Номер счета",
    "addButtonText": "Добавить",
    "addChatMemberText": "Добавить участника разговора",
    "addFailedText": "Ошибка добавления",
    "addFriendFailedText": "Ошибка добавления друзей",
    "addFriendMode": "Добавить режим друзей",
    "addFriendSuccessText": "Добавить друзей успешно",
    "addFriendText": "Добавить друзей",
    "addMessageTop": "Поддерживает сообщение.",
    "addStickTopText": "Заголовок сообщения",
    "addSuccessText": "Добавить успех",
    "addTeamMemberConfirmText": "Выберите участника группы для добавления",
    "addTeamMemberFailedText": "Ошибка добавления членов",
    "addTeamMemberSuccessText": "Добавить участника успешно",
    "addTeamMemberText": "Добавить члена",
    "addTeamMemberVerifyText": "Ожидание проверки",
    "addressText": "Справочник",
    "aiAntiSpamText": "Искусственный интеллект запрашивает анти - мусор",
    "aiBlockFailedText": "Запрещается использовать черный список цифровых людей",
    "aiConversationSelectFailed": "Ошибка выбора сеанса ИИ",
    "aiErrorText": "Сервер занят, попробуйте позже",
    "aiFriendNotExists": "Друзей не существует.",
    "aiFunctionDisabled": "Функция обмена сообщениями не включена.",
    "aiListTitle": "Мой цифровой человек.",
    "aiMemberBanned": "Пользователи запрещены",
    "aiMemberChatBanned": "Пользователям запрещено",
    "aiMenuText": "Мой цифровой человек.",
    "aiMessageHitAntiSpam": "Сообщение попало в корзину",
    "aiNormalTeamChatBanned": "Запрет для обычных членов",
    "aiParameterError": "Ошибка параметра",
    "aiProxyFailedText": "Модель запрашивает аномалии",
    "aiRateLimit": "Превышение частоты",
    "aiSearchInputPlaceholder": "Дополнительный ввод дополнительной информации",
    "aiSearchText": "Поиск слов.",
    "aiSearchingText": "Искать по буквам. Это...",
    "aiSendingText": "Большая модель в ответе.",
    "aiStopFailedText": "Ошибка прекращения вывода",
    "aiStreamCancelText": "Запрос отменен.",
    "aiStreamText": "Цифровой потоковой выход",
    "aiTeamChatBanned": "Члены группы запрещены.",
    "aiTeamMemberNotExists": "Члены группы не существуют",
    "aiTranslateEmptyText": "Пожалуйста, введите то, что нужно перевести.",
    "aiTranslatePlaceholder": "Перевод на. Это...",
    "aiTranslateText": "Обработка ИИ",
    "aiTranslatedText": "Использование",
    "aiTranslatingText": "ИИ в обработке. Это...",
    "aiUserText": "Цифровой человек",
    "aleadyInTeamText": "Уже в группе",
    "aliasText": "Примечания",
    "allReadText": "Все прочитано",
    "allUnReadText": "Все непрочитано",
    "amap": "Карта Гауда",
    "applyFriendFailedText": "Ошибка добавления друзей",
    "applyFriendSuccessText": "Добавление друзей успешно",
    "applyFriendText": "Добавить Вас в качестве друга",
    "applyTeamSuccessText": "Успешно подана заявка",
    "applyTeamText": "Заявка на вход в группу",
    "audioMsgText": "Звуковое сообщение",
    "bdmap": "Сотня карт",
    "beAddTeamManagersText": "Назначен администратором",
    "beMentioned": "[Кто - то @ Я]",
    "beRejectResultText": "Отказали в просьбе друзей.",
    "beRemoveTeamManagersText": "Удалить администратора",
    "beRemoveTeamText": "Выйти из группы",
    "blackFailedText": "Черный провал",
    "blackListDesc": "(Вы не будете получать сообщения о контактах в списке)",
    "blackListTitle": "Черный список",
    "blackMenuText": "Черный список",
    "blackSuccessText": "Черный успех",
    "blackText": "Черные друзья",
    "callBusyText": "Они заняты.",
    "callCancelText": "Отменён",
    "callDurationText": "Длительность разговора",
    "callFailed": "Ошибка вызова",
    "callMsgText": "Сообщение",
    "callRejectedText": "Отказано",
    "callTimeoutText": "Время истекло.",
    "cancelText": "Отменить",
    "cancelUploadFailedText": "Ошибка отмены загрузки",
    "chatButtonText": "Поговори.",
    "chatHistoryText": "Запись разговора",
    "closeAgreeModeText": "Закрыты приглашения. Требуется согласие.",
    "closeApplyModeText": "Закрытие группового аудита.",
    "closeText": "Закрыть",
    "collection": "Коллекция",
    "collectionFailed": "Сбор не удался",
    "collectionSuccess": "Коллекция",
    "collectionText": "Коллекция",
    "commentText": "Сообщение",
    "confirmDeleteFriendText": "Удалить друзей?",
    "confirmDeleteText": "Определить удаление?",
    "confirmRemoveCollection": "Подтвердить удаление коллекции?",
    "createButtonText": "Создание",
    "createDiscussionText": "Создание дискуссионной группы",
    "createTeamFailedText": "Ошибка создания группы",
    "createTeamMemberLimitText": "Верхний предел численности группы",
    "createTeamSuccessText": "Создание группы успешно",
    "createTeamText": "Создание групп",
    "customMsgText": "Настройка сообщений",
    "deleteFriendFailedText": "Ошибка удаления друзей",
    "deleteFriendSuccessText": "Удалить друзей успешно",
    "deleteFriendText": "Удалить друзей",
    "deleteSessionText": "Удалить сеанс",
    "deleteStickTopText": "Снять крышу",
    "deleteText": "Удалить",
    "discussionAvatarText": "Дискуссионная группа",
    "discussionDoNotDisturbText": "Дискуссионная группа без помех",
    "discussionIdText": "Идентификатор дискуссионной группы",
    "discussionMemberText": "Члены дискуссионной группы",
    "discussionText": "Информация дискуссионной группы",
    "discussionTitle": "Название дискуссионной группы",
    "dismissTeamConfirmText": "Подтверждение роспуска группы",
    "dismissTeamFailedText": "Ошибка роспуска группы",
    "dismissTeamSuccessText": "Группа успешно расформирована.",
    "dismissTeamText": "Расформирование групп",
    "editNickInTeamText": "Изменить мое прозвище в группе",
    "emailErrorText": "Неверный формат почтового ящика",
    "emailPlaceholder": "Введите почтовый ящик",
    "emailText": "Почтовый ящик",
    "enText": "English",
    "enableV2CloudConversationText": "Открыть облачный сеанс",
    "enterTeamText": "Входит в группу.",
    "expiredResultText": "Срок годности истек",
    "fileMsgText": "Сообщение файла",
    "forwardFailedText": "Ошибка пересылки",
    "forwardSuccessText": "Передача успешно",
    "forwardText": "Передача",
    "friendListTitle": "Мой друг.",
    "friendMenuText": "Мой друг.",
    "friendText": "Друзья.",
    "genderPlaceholder": "Пожалуйста, выберите пол.",
    "genderText": "Пол",
    "geoMsgShortText": "Местоположение",
    "geoMsgText": "Географическое сообщение",
    "getApplyMsgFailedText": "Ошибка получения сообщения",
    "getCollectionFailed": "Ошибка запроса списка коллекций",
    "getHistoryMsgFailedText": "Ошибка получения исторических сообщений",
    "getRelationFailedText": "Сбой в отношениях",
    "huff": "[Гнев]",
    "ill": "[Неудобно]",
    "imgMsgText": "Фотография сообщения",
    "imgText": "Фотографии",
    "inCallText": "Уже на связи. Пожалуйста, позвоните после окончания разговора.",
    "inviteTeamText": "Приглашаю вас присоединиться.",
    "inviteText": "Приглашение",
    "joinTeamFailedText": "Ошибка присоединения к группе",
    "joinTeamSuccessText": "Успешное присоединение к группе",
    "joinTeamText": "Присоединяйтесь к группе",
    "joinTeamWithVerifyText": "Заявки на вход отправлены.",
    "languageText": "Язык",
    "leaveDiscussionButtonText": "Выход из дискуссионной группы",
    "leaveDiscussionConfirmText": "Подтверждение выхода из дискуссионной группы",
    "leaveDiscussionFailedText": "Ошибка выхода из группы",
    "leaveDiscussionSuccessText": "Удалось выйти из группы",
    "leaveDiscussionText": "Вышла из дискуссионной группы.",
    "leaveDiscussionTitle": "Выход из дискуссионной группы",
    "leaveTeamButtonText": "Удалить и выйти",
    "leaveTeamConfirmText": "Подтверждение выхода из группы",
    "leaveTeamFailedText": "Ошибка выхода из группы",
    "leaveTeamSuccessText": "Удалось выйти из группы",
    "leaveTeamText": "Покинул группу.",
    "leaveTeamTitle": "Выйти из группы",
    "logoutConfirmText": "Уверены в выходе из реестра?",
    "logoutText": "Выход из системы",
    "man": "Мужчины",
    "maxSelectedText": "В лучшем случае можно выбрать",
    "memberNotExistsText": "Пользователь не существует",
    "msgListTitle": "Информационный центр",
    "msgMenuText": "Информационный центр",
    "msgRecallTimeErrorText": "Больше времени не может быть отозвано",
    "muteAllTeamFailedText": "Открывать полный запрет не удалось",
    "muteAllTeamSuccessText": "Открываем все запреты успешно",
    "muteSessionText": "Открыть без помех",
    "needBeInvitedText": "Требуется согласие приглашенного.",
    "needMentionText": "Нужны ли сообщения @",
    "needVerifyText": "Требуется проверка",
    "networkDisconnectText": "Сетевое подключение отключено, проверьте настройки сети и попробуйте снова подключиться",
    "newGroupOwnerText": "Станьте новым владельцем",
    "nickInTeamText": "Мое прозвище в группе.",
    "nickPlaceholder": "Введите псевдоним",
    "nickText": "Прозвище",
    "noMoreCollectionText": "Скатился до самого низа.",
    "noMoreText": "Больше никаких новостей.",
    "noPermission": "У вас нет прав",
    "noText": "Нет",
    "notAnAi": "Это не цифровой аккаунт.",
    "notNeedBeInvitedText": "Не нужно согласие приглашенного.",
    "notNeedVerifyText": "Нет необходимости проверять",
    "notSupportJoinText": "Дискуссионная группа не может присоединиться напрямую, свяжитесь с администратором, чтобы втянуть вас в группу",
    "notSupportMessageText": "Пока не поддерживаю эту новость.",
    "notiMsgText": "Уведомление",
    "offlineText": "(В автономном режиме)",
    "ok": "[OK]",
    "okText": "Определение",
    "onDismissDiscussionText": "Дискуссионная группа была распущена.",
    "onDismissTeamText": "Группа была расформирована.",
    "onRemoveTeamText": "Вы были удалены из группы.",
    "onlineText": "(Онлайн)",
    "onlyTeamOwner": "Только хозяева",
    "openAgreeModeText": "Открыто приглашение в группу. Требуется согласие.",
    "openApplyModeText": "Открылся групповой аудит.",
    "openText": "Открыть",
    "oppositeSide": "Друг друга.",
    "p2pMsgVisibleModeText": "Показать непрочитанное сообщение p2p",
    "passFriendAskText": "Я согласился с вашей заявкой и начну разговор.",
    "passResultText": "Прием заявок от друзей.",
    "personUnit": "Человек",
    "phonePlaceholder": "Пожалуйста, введите номер телефона.",
    "phoneText": "Мобильные телефоны",
    "pinAIText": "PIN Верхний",
    "processedValidationMessageText": "Сообщение о проверке было обработано",
    "readText": "Прочитано",
    "recallMessageText": "Отзыв сообщения.",
    "recallReplyMessageText": "Сообщение отозвано или удалено",
    "recallText": "Снятие",
    "receiveText": "Вы получили новое сообщение.",
    "recentConversationText": "Последний сеанс",
    "recentForwardText": "Последние пересылки",
    "recentSessionText": "Последние посещения",
    "reeditText": "Изменить",
    "regenAIMsgFailedText": "Ошибка воссоздания",
    "rejectFailedText": "Отказ в подаче заявления провалился",
    "rejectResultText": "Отказано",
    "rejectTeamFailedText": "Ошибка группового отказа",
    "rejectTeamInviteText": "Отказался от группового приглашения.",
    "rejectText": "Отказ",
    "rejectedTeamText": "Заявки группы отклонены.",
    "rejectedText": "Заявление было отклонено.",
    "removeBlackFailedText": "Ошибка деактивации",
    "removeBlackSuccessText": "Удаление Раха успешно",
    "removeBlackText": "Удаление Рахея.",
    "removeCollectionFailed": "Ошибка удаления коллекции",
    "removeCollectionSuccess": "Удалить коллекцию успешно",
    "removeMessageTop": "Удаление верхнего сообщения",
    "removeTeamMemberConfirmText": "Подтверждается ли удаление этого члена?",
    "removeTeamMemberFailedText": "Ошибка удаления участника",
    "removeTeamMemberSuccessText": "Удалить участника успешно",
    "removeTeamMemberText": "Удалить участника",
    "replyText": "Ответить",
    "robotMsgText": "Машинное сообщение",
    "saveFailedText": "Ошибка сохранения",
    "saveSuccessText": "Сохранить успешно",
    "saveText": "Сохранить",
    "sdkVersionSelectionText": "Выбор версии SDK",
    "searchButtonText": "Поиск",
    "searchDiscussionMemberPlaceholder": "Поиск членов дискуссионной группы",
    "searchDiscussionTitle": "Дискуссионные группы",
    "searchEmptyText": "Вы не добавляете друзей и группы",
    "searchFriendTitle": "Друзья.",
    "searchInputPlaceholder": "Поиск",
    "searchNoResText": "Нет результатов поиска",
    "searchTeamMemberPlaceholder": "Поиск членов группы",
    "searchTeamPlaceholder": "Введите имя группы",
    "searchTeamTitle": "Группа",
    "searchText": "Поиск",
    "searchTipText": "Enter Поиск",
    "securityTipText": "Только для того, чтобы испытать функции облачных продуктов IM, не доверяйте денежным переводам, выигрышам и другой информации, связанной с деньгами, не легко звонить по незнакомым телефонам, остерегайтесь быть обманутым.",
    "selectedText": "Выбранные",
    "sendBlackFailedText": "Вы попали в черный список.",
    "sendBtnText": "Отправить",
    "sendEmptyText": "Невозможно отправить пустое сообщение",
    "sendMsgFailedText": "Ошибка отправки сообщения",
    "sendNotFriendFailedText": "Текущие отношения не с друзьями",
    "sendText": "Отправить сообщение",
    "sendToText": "Отправить в",
    "sendUsageText": "(Отправить непосредственно по enter, поменять строку на shift + enter)",
    "session": "Сеанс",
    "setText": "Настройка",
    "settingText": "Настройка",
    "signPlaceholder": "Введите подпись",
    "signText": "Подпись",
    "strangerNotiText": "В настоящее время не является вашим другом, обратите внимание на защиту личной конфиденциальности.",
    "strangerText": "Незнакомец.",
    "teamAgreeModeExplainText": "После открытия членам группы требуется согласие владельца группы или администратора.",
    "teamAgreeModeText": "Аудит входящей группы",
    "teamAll": "Все.",
    "teamAtModeText": "Кто может всех",
    "teamAvatarConfirmText": "Групповой портрет не может быть пустым.",
    "teamAvatarText": "Групповое изображение",
    "teamDoNotDisturbText": "Беспокойство групп",
    "teamIdNotMatchText": "Нет номера группы.",
    "teamIdPlaceholder": "Введите идентификатор группы",
    "teamIdText": "Идентификатор группы",
    "teamInfoText": "Групповые данные",
    "teamInviteModeText": "Кто может пригласить новых членов",
    "teamJoinModeExplainText": "После открытия, втягивание в группу требует согласия приглашенного",
    "teamJoinModeFreeText": "Свободное присоединение, без проверки",
    "teamJoinModeNeedVerifyText": "Требуется согласие владельца группы или администратора, чтобы присоединиться",
    "teamJoinModeText": "Приглашение к участию требует согласия",
    "teamListTitle": "Моя группа.",
    "teamManagerEditText": "Управление кадрами",
    "teamManagerEmptyText": "Нет менеджеров групп",
    "teamManagerEnableText": "Включить функцию группового администратора",
    "teamManagerLimitText": "Кто может изменять данные",
    "teamManagerText": "Администратор групп",
    "teamMemberLimitText": "Количество членов группы достигло верхнего предела.",
    "teamMemberNotExist": "Этот разговор больше не существует.",
    "teamMemberText": "Члены группы",
    "teamMenuText": "Моя группа.",
    "teamMsgVisibleModeText": "Показать непрочитанное групповое сообщение",
    "teamMutePlaceholder": "В настоящее время групповые разговоры запрещены.",
    "teamMuteText": "Групповой запрет",
    "teamNotExitsText": "Группы не существует",
    "teamOwnerAndManagerText": "Руководитель группы и администратор",
    "teamOwnerText": "Руководитель группы",
    "teamPowerText": "Управление группами",
    "teamSignPlaceholder": "Введите содержимое",
    "teamSignText": "Презентация группы",
    "teamTitle": "Название группы",
    "teamTitleConfirmText": "Имя группы не может быть пустым",
    "teamTitlePlaceholder": "Введите имя группы",
    "teamTopModeText": "Кто может скачать новости",
    "textMsgText": "Текстовое сообщение",
    "tipAIFailedMessageText": "Ошибка запроса модели большого языка",
    "tipAIMessageText": "Формат не поддерживается",
    "tipMsgText": "Подсказка",
    "topFailedText": "Не удалось поднять верх",
    "topText": "Ставить верх",
    "transferOwnerConfirmText": "Подтверждение передающего субъекта",
    "transferOwnerText": "Передача владельца группы",
    "transferTeamFailedText": "Ошибка передачи владельца группы",
    "transferTeamSuccessText": "Передача успешно",
    "transferToText": "Передача",
    "txmap": "Скачать карту",
    "unTopText": "Снять крышу",
    "unknow": "Неизвестно",
    "unknowMsgText": "Неизвестное сообщение",
    "unmuteAllTeamFailedText": "Окончание полного запрета провалилось.",
    "unmuteAllTeamSuccessText": "Окончание полного запрета.",
    "unmuteSessionText": "Отмена помех",
    "unreadText": "Непрочитанные",
    "updateAliasFailedText": "Ошибка изменения заметки",
    "updateAliasSuccessText": "Изменить примечание успешно",
    "updateAllowAt": "Обновлено \"@ Все права\" для",
    "updateAllowTop": "Права верхнего сообщения обновлены как",
    "updateBitConfigMaskFailed": "Ошибка обновления группового сообщения без помех",
    "updateBitConfigMaskSuccess": "Обновление группового сообщения без помех",
    "updateMyMemberNickFailed": "Ошибка обновления моего группового прозвища",
    "updateMyMemberNickSuccess": "Обновить групповое прозвище успешно",
    "updateTeamAvatar": "Обновлены групповые заголовки.",
    "updateTeamFailedText": "Ошибка изменения",
    "updateTeamIntro": "Обновлено представление группы",
    "updateTeamInviteMode": "Обновлены групповые права \"Пригласить других\" как",
    "updateTeamManagerFailText": "Ошибка изменения администратора группы",
    "updateTeamManagerSuccessText": "Изменение администратора группы успешно",
    "updateTeamMute": "Обновлен « Запрет группы» для",
    "updateTeamName": "Название группы обновлений",
    "updateTeamSuccessText": "Изменение успешно",
    "updateTeamUpdateTeamMode": "Обновлены права группы \"Права изменения групповых данных\" как",
    "uploadImgFailedText": "Ошибка загрузки изображения",
    "uploadLimitText": "Максимальная поддержка изображения видео или файла",
    "uploadLimitUnit": "M",
    "userNotInTeam": "Членов больше нет в группе.",
    "vedioCallText": "Видеоконференция",
    "verifyMsgNotExitsText": "Сообщение о проверке было обработано",
    "videoMsgText": "Видео сообщение",
    "videoText": "Видео",
    "voiceCallText": "Голосовой разговор",
    "voiceToText": "Голосовой перевод",
    "voiceToTextFailedText": "Ошибка перевода",
    "welcomeText": "Добро пожаловать в облако",
    "woman": "Женщины",
    "yesText": "Да.",
    "you": "Ты...",
    "zhText": "Китайский язык"
}

export default LocaleConfig
